import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'

export default createVuetify({
    blueprint: md3,
    theme: {
        defaultTheme: 'customLight',
        themes: {
            customLight: {
                dark: false,
                colors: {
                    primary: '#0f6057',
                    secondary: '#E9EBF8',
                    accent: '#F15025',
                    background: '#f5f7f6',
                    surface: '#ffffff',
                    success: '#8ab9b5',
                    warning: '#c8c2ae',
                    error: '#d32f2f',
                    info: '#0eb1d2'
                }
            }
        }
    }
})